import {
	EnhancedPrimeReactDatePicker,
	IEnhancedPrimeReactDatePicker,
} from "./EnhancedPrimeReactDatePicker";
import {
	FieldLayout,
	LabelPosition,
	RHookFormTextField,
} from "@websential/cosmic-v20";
import React, { FC } from "react";

import { GridSize } from "@mui/material";
import { useController } from "react-hook-form";

/**
 * Text fields allow users to enter text into a UI. They typically appear in forms and dialogs.
 * The EnhancedTextInputWR wrapper component is a complete form control using Material UI TextField including
 * a label, input, and help text. Websential is using the outlined variants.
 */
export interface IRHookFormDatePickerWithRange
	extends Pick<
		IEnhancedPrimeReactDatePicker,
		Exclude<
			keyof IEnhancedPrimeReactDatePicker,
			"onChange" | "value" | "helperText"
		>
	> {
	defaultValue?: Date | string | null;
	showlabel?: boolean;
}

export const RHookFormDatePickerWithRange: FC<IRHookFormDatePickerWithRange> = ({
	name,
	defaultValue = null,
	label,
	showlabel = true,
	labelPosition = LabelPosition.Top,
	labelColumns = 4 as GridSize,
	fieldColumns = 8 as GridSize,
	format = "M dd, yy",
	disabled = false,
	disableFuture = false,
	required = false,
	// masked = true,
	maxDate,
	minDate,
	testId,
	viewDate,
	onDateSelectionChangeHandler
}: IRHookFormDatePickerWithRange) => {
	const {
		field: { onChange, value },
		formState: { errors },
	} = useController({
		name: name,
		defaultValue: defaultValue,
	});

	const handleChange = (newValue: any) => {
		onChange(newValue); // Update react-hook-form
		if (onDateSelectionChangeHandler) {
			onDateSelectionChangeHandler(newValue); // Custom handler (optional)
		}
	};

	return (
		<>
			{/* {value !== null && typeof(value) !== 'object' && value.charAt(3) === "*" ?
    <FieldLayout
    label={label}
    isRequired={required}
    testId={testId}
    labelPosition={labelPosition}
    labelColumns={labelColumns}
    fieldColumns={fieldColumns}
  >
      <RHookFormTextField
      id={name}
      fieldValue={"Unmask to view / edit"}
      defaultValue={"Unmask to view / edit"}
      placeholder={"Unmask to view / edit"}
      testId={name}
      uppercase={false}
      readOnly={true}
    />
    </FieldLayout>
    : */}
			<EnhancedPrimeReactDatePicker
				name={name}
				label={label}
				showlabel={showlabel}
				value={value === undefined ? null : value}
				onChange={handleChange}
				labelPosition={labelPosition}
				labelColumns={labelColumns}
				fieldColumns={fieldColumns}
				format={format}
				disabled={disabled}
				disableFuture={disableFuture}
				required={required}
				minDate={minDate}
				maxDate={maxDate}
				helperText={errors[name]?.message}
				testId={testId}
				viewDate={viewDate}
			/>
			{/* } */}
		</>
	);
};
